import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar10Colors = {
  background?: string;
  skin?: string;
  hair?: string;
  accessories?: string;
};

export const Avatar10 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar10Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
    accessories: colors.accessories ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar10">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 302.846c83.856 0 151.834-67.794 151.834-151.423S235.689 0 151.833 0C67.978 0 0 67.794 0 151.423s67.978 151.423 151.833 151.423Z"
            fill={c.background}
          />
          <Path
            id="skin"
            d="M201.393 174.424c3.019-11.445 1.275-11.254 2.78-25.026 5.67-37.171 6.363-82.658-28.527-86.446-62.995-6.846-72.409 20.928-76.964 62.65a78.647 78.647 0 0 0-.438 6.664c-1.203-.247-2.588-.207-4.197.182-4.898 1.168-7.208 9.055-5.153 17.617 2.055 8.562 7.693 14.55 12.591 13.375.327-.08.645-.191.948-.326 1.8 6.203 4.165 12.271 7.048 17.966a8.851 8.851 0 0 0-.255-.484c-1.879 14.939-4.531 39.855-6.833 46.296-3.72 10.405-17.377 15.798-17.377 15.798s46.398 60.609 72.814 60.942c15.888 1.39 17.983-39.807 17.983-39.807s-13.841-7.292-16.661-14.289c-1.194-2.97 1.434-18.792 3.305-30.149 9.645-.08 23.263-12.82 38.936-44.955v-.008Z"
            fill={c.skin}
          />
          <Path
            id="Vector"
            d="M121.77 123.704s11.253-1.883 19.766-.787c9.995 1.287 16.422 8.396 18.66 5.433.709-.945.804-6.346-17.258-10.317-8.084-1.779-13.228 1.215-21.16 5.679l-.008-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_2"
            d="M206.594 129.311c-22.562-5.155-29.26 2.629-28.177 4.67.669 1.263 2.628 1.62 4.579.485 4.229-3.519 11.293-4.551 22.921-.731.454-1.311.573-3.296.677-4.424Z"
            fill="#000"
          />
          <Path
            id="Vector_3"
            d="M178.417 133.982c-.199-.374-.135-.945.247-1.597-9.995 11.803-.35 33.589-5.407 36.949-3.536 2.351-15.355-2.756-16.215.643 4.141 3.383 16.159 7.037 20.603.731 1.832-3.304-5.272-27.402 5.352-36.242-1.952 1.128-3.911.779-4.58-.484Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="Vector_4"
            d="M129.04 224.485c10.886 12.216 22.323 16.815 30.016 18.522.557-6.409 2.15-16.02 3.408-23.629-.374 0-.74 0-1.099-.039-13.021-1.247-27.81-6.807-40.361-21.016-4.571-5.171-8.506-11.215-11.763-17.736-.048.405-.103.818-.151 1.231.971 9.214 4.93 25.798 19.958 42.675l-.008-.008Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="hair"
            d="M38.26 147.627c.923-8.483 11.722-8.657 12.965-11.461 1.242-2.804-1.235-3.749-.327-7.712.9-3.964 3.17-3.265 4.324-7.434 1.155-4.162-5.152-6.434-1.592-13.272 3.56-6.839 8.903-3.106 14.176-7.49 5.447-4.535 1.011-11.405 4.037-17.624 3.027-6.22 11.747-4.591 13.97-7.736 2.221-3.145-1.681-6.052 4.021-11.08 5.702-5.028 8.713-.405 15.426-3.971 6.714-3.559 2.509-10.111 21.216-16.21 12.504-4.075 15.06 3.669 22.936 4.526 7.877.858 10.21-7.696 20.747-5.424 10.528 2.271 14.04 13.041 19.376 15.654 5.336 2.613 12.089-3.43 21.049 2.51 8.959 5.941 8.028 14.424 10.345 18.959 2.318 4.543 11.85 4.718 17.099 11.365 5.248 6.64.071 17.585.143 21.429.08 3.844 8.163 4.241 10.441 10.722 2.278 6.482-3.791 11.89-4.779 16.418-.995 4.527 7.065 6.679 7.359 19.173.295 12.493-21.256 16.472-15.291 29.18 2.835 6.052 10.664 2.597 10.664 2.597s-1.656 6.053-6.076 10.048-15.275 1.691-15.275 1.691 1.545 8.634.334 13.622c-1.21 4.98-11.771 3.034-11.771 3.034s-1.345 6.242-5.2 12.7c-3.855 6.449-17.354 4.026-20.754 4.773-3.401.747-2.039 9.523-7.271 10.397-5.233.865-7.924-1.819-13.882-5.028-5.949-3.201-3.607-.389-6.554-.715a5.58 5.58 0 0 0-.884-.016c.661-6.322 2.095-14.939 3.241-21.889 9.645-.071 23.263-12.811 38.936-44.954 1.354-5.131 1.744-7.927 1.912-10.683.637-4.289.215-6.759.82-13.828.016-.174.032-.341.056-.516.971-6.346 1.792-12.938 2.317-19.515.51-5.972.773-11.953.637-17.759-.024-.04-.039-.079-.063-.119a28.083 28.083 0 0 1-2.509-5.885c-2.628-8.825-3.448-14.448-10.234-15.877-6.785-1.43-7.422 2.192-10.21 1.43-2.787-.763-9.516-9.341-18.842-9.428-9.326-.088-7.208 11.214-14.335 15.05-7.12 3.837-10.863-1.413-16.797 2.558-5.941 3.971-4.109 11.318-6.45 15.218-2.342 3.9-3.951-1.12-6.786 2.954-1.839 2.637-2.118 21.064-2.636 22.827-.852 2.899-6.14 6.815-9.341 8.967.613-3.066.278-4.71-.685-8.538-1.848-7.323-4.317-9.92-9.98-9.515-1.242.087-2.635.318-4.22.675-5.28 1.199-7.399 8.681-5.153 17.616 1.983 7.879 7.335 8.65 12.193 7.895 1.601 6.727 3.855 13.383 6.73 19.65-2.246 13.399-4.954 26.885-6.507 31.706-3.743 11.652-19.48 16.941-19.48 16.941s1.728 2.653 4.683 6.886a541.74 541.74 0 0 1-10.688-2.136c-4.698-.993-4.021-5.711-4.021-5.711s-7.965-.834-13.476-6.179c-5.51-5.337-.23-17.187-1.983-22.572-1.752-5.385-12.455-6.092-14.271-13.066-1.816-6.973 1.29-7.537 2.89-15.718 1.602-8.181-7.629-11.667-6.705-20.142l-.016.032Z"
            fill={c.hair}
          />
          <Path
            id="accessories"
            d="M180.639 207.838c1.219 1.565 2.772 2.573 4.54 2.764 4.826.524 9.405-5.178 10.233-12.732.39-3.598-.143-6.957-1.33-9.555 1.88-3.28 3.791-6.846 5.742-10.714 2.851 5.202 4.213 12.39 3.369 20.134-1.593 14.606-10.449 25.623-19.774 24.606-4.142-.453-7.678-3.201-10.194-7.402 2.349-1.787 4.826-4.138 7.414-7.101Z"
            fill={c.accessories}
          />
          <Path
            id="accessories_2"
            d="M78.199 180.707c-1.768 16.171 5.169 30.189 15.498 31.309 10.329 1.12 20.133-11.08 21.893-27.251 1.768-16.171-5.169-30.189-15.498-31.309-10.33-1.12-20.133 11.08-21.893 27.251Zm8.378 2.009c.916-8.363 5.989-14.678 11.325-14.098 5.344.58 8.935 7.832 8.02 16.203-.916 8.363-5.99 14.678-11.325 14.098-5.336-.58-8.928-7.832-8.02-16.203Z"
            fill={c.accessories}
          />
          <G id="Group_2" fill="#000">
            <Path
              id="Vector_5"
              d="M143.853 129.883c-2.294-.532-4.667-.516-6.969.127-1.879.516-3.4 1.541-4.866 2.581-1.959 1.096-4.308.342-6.458-.159 1.895 1.716 4.818 3.233 7.462 2.232a22.724 22.724 0 0 1 1.855-.858 4.578 4.578 0 0 0-.095.564c-.382 3.471 2.134 6.593 5.614 6.966 3.481.373 6.611-2.129 6.985-5.6.032-.286.04-.564.032-.842 2.341 1.438 4.635 3.44 7.151 5.632-1.999-4.631-5.662-9.102-10.703-10.635l-.008-.008Z"
            />
            <Path
              id="Vector_6"
              d="M203.145 142.932c-1.211-1.326-2.469-2.652-4.197-3.566-2.111-1.12-4.428-1.644-6.778-1.62-5.256.413-9.795 3.995-12.75 8.085 1.505-.826 2.947-1.612 4.34-2.303a5.966 5.966 0 0 0 5.32 6.1 5.972 5.972 0 0 0 6.586-5.282 5.883 5.883 0 0 0-.525-3.121c2.094.476 4.261 1.572 6.586 3.51 2.365 1.549 5.551.691 7.773-.572-2.214.024-4.675.255-6.347-1.231h-.008Z"
            />
          </G>
          <G id="Group_3" fill="#000">
            <Path
              id="Vector_7"
              d="M221.653 285.897c-12.479-6.949-33.002-17.87-45.84-22.08 0 0-1.625 32.024-12.902 38.648a151.233 151.233 0 0 0 58.742-16.568Z"
            />
            <Path
              id="Vector_8"
              d="m85.015 242.673-43.563 12.716c23.9 25.265 56.592 42.5 93.927 46.559 5.774.627 11.516.921 17.187.905-26.863-7.029-67.55-60.172-67.559-60.18h.008Z"
            />
          </G>
          <Path
            id="Vector_9"
            d="M173.01 182.859c-3.408-.373-6.068 1.279-6.068 1.279s-2.724-2.661-6.348-3.058c-3.623-.397-7.151 1.374-10.624 1.533-2.819.127-9.381-1.144-9.381-1.144s11.492 18.101 23.008 19.348c10.026 1.088 16.86-11.239 16.86-11.239s-4.5-6.401-7.455-6.719h.008Zm-7.43 11.636c-11.15-1.216-18.994-8.094-23.04-11.866 4.157 2.756 12.79 6.06 23.948 7.275 5.192.564 9.31.556 12.623-.072-3.425 1.645-8.339 5.235-13.531 4.663Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
        </G>
      </G>
    </Svg>
  );
};
